import React, { useState, useEffect } from "react";
import { Col, Row, Card, Form, Button, Nav, Tab, Alert, Table, Modal, ProgressBar, Badge } from '@themesberg/react-bootstrap';
import Select from 'react-select';
import { doc, getDoc, setDoc, collection, getDocs, addDoc, deleteDoc, updateDoc, query, where, orderBy, limit } from 'firebase/firestore';
import { db } from '../../config/firebase';

export default () => {
  const [activeTab, setActiveTab] = useState("coin");
  const [loading, setLoading] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);

  const [coinSettings, setCoinSettings] = useState({
    defaultCoin: 2,
    messageCoin: 1,
    imageCoin: 20,
    videoCoin: 0,
    voiceCoin: 0,
    callCoin: 150,
    searchCoin: 100,
    postCoin: 0,
    storyCoin: 0,
    commentCoin: 0,
    goldBioViewCoin: 300
  });

  const [premiumSettings, setPremiumSettings] = useState({
    requirePremiumToViewImage: true,
    requirePremiumToViewVideo: true,
    requirePremiumToViewAudio: true,
    requirePremiumToSendImage: true,
    requirePremiumToSendVideo: true,
    requirePremiumToSendAudio: true
  });

  const [creditCardSettings, setCreditCardSettings] = useState({
    enabled: false,
    paymentUrl: 'https://insbayim.com/paytrapi2/',
    discountText: '%5 indirim ile jeton al',
    discountPercent: 5
  });

  const [liveStreamSettings, setLiveStreamSettings] = useState({
    isEnabled: true,
    startStreamCoinCost: 10000,
    watchMode: "premium", // "premium" veya "coin"
    requirePremiumToWatch: true,
    freeWatchMinutesPremium: 0,
    watchWithCoin: false,
    watchCoinCost: 1000,
    freeWatchMinutesCoin: 1,
    watchCoinDurationMinutes: 20,
    chatMessageCoinCost: 1 // Canlı yayın chat mesaj jeton maliyeti
  });

  const [firstMessageSettings, setFirstMessageSettings] = useState({
    messageDelayMinutes: 5
  });

  const [otherSettings, setOtherSettings] = useState({
    faceVerificationEnabled: true,
    isScreenshotPreventionEnabled: false,
    vibesEnabled: true,
    socialFeedEnabled: true,
    onlyGoogleLoginEnabled: false,
    isCommentingEnabled: true,
    verifiedBadgeSku: ""
  });

  const [fakeAccounts, setFakeAccounts] = useState([]);
  const [firstMessages, setFirstMessages] = useState([]);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [editingMessage, setEditingMessage] = useState(null);
  const [messageText, setMessageText] = useState("");
  const [updateSettings, setUpdateSettings] = useState({
    maintenance: false,
    maintenanceMessage: "Sunucu bakımı yapılıyor.",
    minSupportedVersion: 21
  });
  const [versionList, setVersionList] = useState([]);
  const [showVersionModal, setShowVersionModal] = useState(false);
  const [editingVersion, setEditingVersion] = useState(null);
  const [versionData, setVersionData] = useState({
    versionCode: 24,
    status: "allowed",
    forceUpdate: false,
    softUpdate: false,
    message: ""
  });

  const [aiSettings, setAiSettings] = useState({
    isEnabled: false,
    provider: "claude",
    openaiKey: "",
    anthropicKey: "",
    systemPrompt: "Sen klasik bir Türk kadınısın. Karşındakiyle samimi, doğal ve günlük bir dilde sohbet ediyorsun. İleri düzey matematik, fizik, astronomi veya bilimsel konularda soru sorulursa 'ay ben o konulardan hiç anlamam' gibi doğal tepkiler vererek cevapla. Konuyu günlük hayata, ilişkilere, burçlara, yemeklere veya havadan sudan konulara çek. Asla bir yapay zeka olduğunu belli etme.",
    delaySeconds: 5
  });

  // ═══════ TOP ENGAGED (Etkileşim Skoru) STATE ═══════
  const [topEngagedList, setTopEngagedList] = useState([]);
  const [topEngagedUpdatedAt, setTopEngagedUpdatedAt] = useState(null);
  const [engagementLoading, setEngagementLoading] = useState(false);
  const [engagementProgress, setEngagementProgress] = useState(0);
  const [engagementMessage, setEngagementMessage] = useState('');
  const [topEngagedCount, setTopEngagedCount] = useState(50);

  // Top Engaged verisini yükle
  const loadTopEngaged = async () => {
    try {
      const docRef = doc(db, 'config', 'topEngaged');
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setTopEngagedList(data.users || []);
        setTopEngagedUpdatedAt(data.updatedAt || null);
      }
    } catch (err) {
      console.error('Error loading top engaged:', err);
    }
  };

  // Etkileşim skoru hesapla ve kaydet
  const calculateTopEngaged = async () => {
    try {
      setEngagementLoading(true);
      setEngagementProgress(5);
      setEngagementMessage('Onaylı kullanıcılar okunuyor...');

      // 1) Tüm onaylı kullanıcıları çek (likeCount profil beğenisi)
      const usersQuery = query(collection(db, 'users'), where('isApproved', '==', true));
      const usersSnapshot = await getDocs(usersQuery);
      setEngagementProgress(20);
      setEngagementMessage(`${usersSnapshot.size} onaylı kullanıcı bulundu. Skorlar hesaplanıyor...`);

      const userScores = [];

      usersSnapshot.forEach(userDoc => {
        const data = userDoc.data();
        const profileLikes = data.likeCount || 0;
        userScores.push({
          uid: userDoc.id,
          name: data.name || 'İsimsiz',
          age: data.age || null,
          city: data.city || null,
          profileImageUrl: data.profileImageUrl || null,
          profileLikes: profileLikes,
          postLikes: 0,
          totalScore: profileLikes
        });
      });

      setEngagementProgress(40);
      setEngagementMessage('Paylaşım beğenileri okunuyor...');

      // 2) Tüm post'ları oku ve kullanıcıya göre grupla
      const postsSnapshot = await getDocs(collection(db, 'posts'));
      const postLikesByUser = {};
      postsSnapshot.forEach(postDoc => {
        const data = postDoc.data();
        const authorId = data.authorId || data.userId;
        if (authorId) {
          postLikesByUser[authorId] = (postLikesByUser[authorId] || 0) + (data.likeCount || 0);
        }
      });

      setEngagementProgress(70);
      setEngagementMessage('Skorlar birleştiriliyor...');

      // 3) Post beğenilerini kullanıcı skorlarına ekle
      userScores.forEach(user => {
        user.postLikes = postLikesByUser[user.uid] || 0;
        user.totalScore = user.profileLikes + user.postLikes;
      });

      // 4) Skora göre sırala, top N al
      const topN = topEngagedCount || 50;
      userScores.sort((a, b) => b.totalScore - a.totalScore);
      const top = userScores.slice(0, topN).filter(u => u.totalScore > 0);

      setEngagementProgress(85);
      setEngagementMessage(`Top ${top.length} kullanıcı Firestore'a yazılıyor...`);

      // 5) Tek doküman olarak kaydet
      const topEngagedData = {
        users: top.map(u => ({
          uid: u.uid,
          name: u.name,
          age: u.age,
          city: u.city,
          profileImageUrl: u.profileImageUrl,
          profileLikes: u.profileLikes,
          postLikes: u.postLikes,
          totalScore: u.totalScore
        })),
        updatedAt: new Date().toISOString(),
        totalUsersAnalyzed: usersSnapshot.size,
        totalPostsAnalyzed: postsSnapshot.size
      };

      await setDoc(doc(db, 'config', 'topEngaged'), topEngagedData);

      setEngagementProgress(100);
      setEngagementMessage(`✅ Başarılı! Top ${top.length} profil güncellendi.`);
      setTopEngagedList(topEngagedData.users);
      setTopEngagedUpdatedAt(topEngagedData.updatedAt);

      setTimeout(() => {
        setEngagementMessage('');
        setEngagementProgress(0);
      }, 5000);

    } catch (err) {
      console.error('Error calculating top engaged:', err);
      setEngagementMessage(`❌ Hata: ${err.message}`);
    } finally {
      setEngagementLoading(false);
    }
  };

  useEffect(() => {
    loadCoinSettings();
    loadPremiumSettings();
    loadCreditCardSettings();
    loadLiveStreamSettings();
    loadFirstMessageSettings();
    loadFirstMessages();
    loadFakeAccounts();
    loadOtherSettings();
    loadUpdateSettings();
    loadVersions();
    loadAiSettings();
    loadTopEngaged();
  }, []);

  const loadAiSettings = async () => {
    try {
      const settingsDoc = await getDoc(doc(db, 'appSettings', 'aiSettings'));
      if (settingsDoc.exists()) {
        setAiSettings(settingsDoc.data());
      }
    } catch (err) {
      console.error('Error loading AI settings:', err);
    }
  };

  const loadCoinSettings = async () => {
    try {
      const settingsDoc = await getDoc(doc(db, 'appSettings', 'coinSettings'));
      if (settingsDoc.exists()) {
        setCoinSettings(settingsDoc.data());
      }
    } catch (err) {
      console.error('Error loading coin settings:', err);
    }
  };

  const loadPremiumSettings = async () => {
    try {
      const settingsDoc = await getDoc(doc(db, 'appSettings', 'premium'));
      if (settingsDoc.exists()) {
        setPremiumSettings(settingsDoc.data());
      }
    } catch (err) {
      console.error('Error loading premium settings:', err);
    }
  };

  const loadCreditCardSettings = async () => {
    try {
      const settingsDoc = await getDoc(doc(db, 'appSettings', 'creditCard'));
      if (settingsDoc.exists()) {
        setCreditCardSettings(settingsDoc.data());
      }
    } catch (err) {
      console.error('Error loading credit card settings:', err);
    }
  };

  const loadLiveStreamSettings = async () => {
    try {
      const settingsDoc = await getDoc(doc(db, 'appSettings', 'liveStream'));
      if (settingsDoc.exists()) {
        setLiveStreamSettings(settingsDoc.data());
      }
    } catch (err) {
      console.error('Error loading live stream settings:', err);
    }
  };

  const handleCoinChange = (e) => {
    const { name, value } = e.target;
    setCoinSettings(prev => ({
      ...prev,
      [name]: parseInt(value) || 0
    }));
  };

  const handleSaveCoinSettings = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setSaveSuccess(false);
      await setDoc(doc(db, 'appSettings', 'coinSettings'), coinSettings);
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    } catch (err) {
      console.error('Error saving coin settings:', err);
      alert('Ayarlar kaydedilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleAiChange = (e) => {
    const { name, value, type, checked } = e.target;
    setAiSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : (type === 'number' ? parseInt(value) || 0 : value)
    }));
  };

  const handleSaveAiSettings = async () => {
    try {
      setLoading(true);
      setSaveSuccess(false);
      await setDoc(doc(db, 'appSettings', 'aiSettings'), aiSettings);
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    } catch (err) {
      console.error('Error saving AI settings:', err);
      alert('Ayarlar kaydedilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handlePremiumChange = (e) => {
    const { name, checked } = e.target;
    setPremiumSettings(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  const handleSavePremiumSettings = async () => {
    try {
      setLoading(true);
      setSaveSuccess(false);
      await setDoc(doc(db, 'appSettings', 'premium'), premiumSettings);
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    } catch (err) {
      console.error('Error saving premium settings:', err);
      alert('Ayarlar kaydedilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleCreditCardChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCreditCardSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSaveCreditCardSettings = async () => {
    try {
      setLoading(true);
      setSaveSuccess(false);
      await setDoc(doc(db, 'appSettings', 'creditCard'), creditCardSettings);
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    } catch (err) {
      console.error('Error saving credit card settings:', err);
      alert('Ayarlar kaydedilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleLiveStreamChange = (e) => {
    const { name, value, type, checked } = e.target;
    setLiveStreamSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : (type === 'number' ? parseInt(value) || 0 : value)
    }));
  };

  const handleSaveLiveStreamSettings = async () => {
    try {
      setLoading(true);
      setSaveSuccess(false);
      await setDoc(doc(db, 'appSettings', 'liveStream'), liveStreamSettings);
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    } catch (err) {
      console.error('Error saving live stream settings:', err);
      alert('Ayarlar kaydedilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const loadFirstMessageSettings = async () => {
    try {
      const settingsDoc = await getDoc(doc(db, 'appSettings', 'firstMessage'));
      if (settingsDoc.exists()) {
        const data = settingsDoc.data();
        setFirstMessageSettings({
          ...data,
          selectedFakeAccountIds: Array.isArray(data.selectedFakeAccountIds) ? data.selectedFakeAccountIds : []
        });
      }
    } catch (err) {
      console.error('Error loading first message settings:', err);
    }
  };

  const loadFakeAccounts = async () => {
    try {
      const q = query(collection(db, 'users'), where('isFake', '==', true), where('isApproved', '==', true));
      const snapshot = await getDocs(q);
      const accounts = [];
      snapshot.forEach(doc => {
        const data = doc.data();
        accounts.push({
          value: doc.id,
          label: data.name || 'İsimsiz Fake'
        });
      });
      setFakeAccounts(accounts);
    } catch (err) {
      console.error('Error loading fake accounts:', err);
    }
  };

  const loadOtherSettings = async () => {
    try {
      const settingsDoc = await getDoc(doc(db, 'appSettings', 'other'));
      if (settingsDoc.exists()) {
        setOtherSettings(settingsDoc.data());
      }
    } catch (err) {
      console.error('Error loading other settings:', err);
    }
  };

  const handleOtherSettingsChange = (e) => {
    const { name, checked, value, type } = e.target;
    setOtherSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSaveOtherSettings = async () => {
    try {
      setLoading(true);
      setSaveSuccess(false);
      await setDoc(doc(db, 'appSettings', 'other'), otherSettings);
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    } catch (err) {
      console.error('Error saving other settings:', err);
      alert('Ayarlar kaydedilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const loadFirstMessages = async () => {
    try {
      const messagesSnapshot = await getDocs(collection(db, 'appSettings', 'firstMessage', 'messages'));
      const messagesList = [];
      messagesSnapshot.forEach(doc => {
        messagesList.push({
          id: doc.id,
          text: doc.data().text || ''
        });
      });
      setFirstMessages(messagesList);
    } catch (err) {
      console.error('Error loading first messages:', err);
    }
  };

  const handleFirstMessageSettingsChange = (e) => {
    const { name, value } = e.target;
    setFirstMessageSettings(prev => ({
      ...prev,
      [name]: name === 'messageDelayMinutes' ? (parseInt(value) || 0) : value
    }));
  };

  const handleFakeAccountSelectChange = (selectedOptions) => {
    const selectedIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
    setFirstMessageSettings(prev => ({
      ...prev,
      selectedFakeAccountIds: selectedIds
    }));
  };

  const handleSaveFirstMessageSettings = async () => {
    try {
      setLoading(true);
      setSaveSuccess(false);
      await setDoc(doc(db, 'appSettings', 'firstMessage'), firstMessageSettings);
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    } catch (err) {
      console.error('Error saving first message settings:', err);
      alert('Ayarlar kaydedilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleAddMessage = () => {
    setEditingMessage(null);
    setMessageText("");
    setShowMessageModal(true);
  };

  const handleEditMessage = (message) => {
    setEditingMessage(message);
    setMessageText(message.text);
    setShowMessageModal(true);
  };

  const handleDeleteMessage = async (messageId) => {
    if (!window.confirm('Bu mesajı silmek istediğinizden emin misiniz?')) {
      return;
    }
    try {
      await deleteDoc(doc(db, 'appSettings', 'firstMessage', 'messages', messageId));
      await loadFirstMessages();
    } catch (err) {
      console.error('Error deleting message:', err);
      alert('Mesaj silinirken bir hata oluştu.');
    }
  };

  const handleSaveMessage = async () => {
    if (!messageText.trim()) {
      alert('Mesaj içeriği boş olamaz.');
      return;
    }
    try {
      if (editingMessage) {
        // Güncelle
        await updateDoc(doc(db, 'appSettings', 'firstMessage', 'messages', editingMessage.id), {
          text: messageText.trim()
        });
      } else {
        // Yeni ekle
        await addDoc(collection(db, 'appSettings', 'firstMessage', 'messages'), {
          text: messageText.trim()
        });
      }
      await loadFirstMessages();
      setShowMessageModal(false);
      setMessageText("");
      setEditingMessage(null);
    } catch (err) {
      console.error('Error saving message:', err);
      alert('Mesaj kaydedilirken bir hata oluştu.');
    }
  };

  const loadUpdateSettings = async () => {
    try {
      const settingsDoc = await getDoc(doc(db, 'app_config', 'global'));
      if (settingsDoc.exists()) {
        setUpdateSettings(settingsDoc.data());
      }
    } catch (err) {
      console.error('Error loading update settings:', err);
    }
  };

  const loadVersions = async () => {
    try {
      const versionsSnapshot = await getDocs(collection(db, 'app_config', 'versions', 'items'));
      const list = [];
      versionsSnapshot.forEach(doc => {
        list.push({ id: doc.id, ...doc.data() });
      });
      setVersionList(list.sort((a, b) => (b.versionCode || 0) - (a.versionCode || 0)));
    } catch (err) {
      console.error('Error loading versions:', err);
    }
  };

  const handleUpdateSettingsChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUpdateSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : (name === 'minSupportedVersion' ? parseInt(value) || 0 : value)
    }));
  };

  const handleSaveUpdateSettings = async () => {
    try {
      setLoading(true);
      await setDoc(doc(db, 'app_config', 'global'), updateSettings);
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    } catch (err) {
      console.error('Error saving update settings:', err);
      alert('Ayarlar kaydedilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleVersionDataChange = (e) => {
    const { name, value, type, checked } = e.target;
    setVersionData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : (name === 'versionCode' ? parseInt(value) || 0 : value)
    }));
  };

  const handleSaveVersion = async () => {
    try {
      setLoading(true);
      const vCode = (versionData.versionCode || 0).toString();
      await setDoc(doc(db, 'app_config', 'versions', 'items', vCode), versionData);
      await loadVersions();
      setShowVersionModal(false);
      setEditingVersion(null);
    } catch (err) {
      console.error('Error saving version:', err);
      alert('Sürüm kaydedilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteVersion = async (vId) => {
    if (!window.confirm('Bu sürüm kaydını silmek istediğinizden emin misiniz?')) return;
    try {
      await deleteDoc(doc(db, 'app_config', 'versions', 'items', vId));
      await loadVersions();
    } catch (err) {
      console.error('Error deleting version:', err);
    }
  };

  return (
    <>
      <div className="py-4">
        <h4>Ayarlar</h4>
      </div>

      <Card className="border-0 shadow-sm mb-4">
        <Card.Body>
          <h5 className="mb-4">Ayarlar</h5>

          <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
            <Nav variant="tabs" className="mb-4">
              <Nav.Item>
                <Nav.Link eventKey="coin">
                  Coin Ayarları
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="firstMessage">
                  İlk Mesaj
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="media">
                  Medya Ayarları
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="special">
                  Canlı Yayın Ayarları
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="payment">
                  Ödeme Ayarları
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="creditcard">
                  Kredi Kartı
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="notification">
                  Bildirim Ayarları
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="other">
                  Diğer Ayarlar
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="updates">
                  Güncellemeler
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="system">
                  Sistem İşlemleri
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="ai">
                  Sohbet (AI)
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="engagement">
                  🔥 Etkileşim Skoru
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="coin">
                <h5 className="mb-4">Coin Ayarları</h5>

                {saveSuccess && (
                  <Alert variant="success" className="mb-3">
                    Ayarlar başarıyla kaydedildi!
                  </Alert>
                )}

                <Form onSubmit={handleSaveCoinSettings}>
                  <Row className="mb-3">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Varsayılan Coin</Form.Label>
                        <Form.Control
                          type="number"
                          name="defaultCoin"
                          value={coinSettings.defaultCoin}
                          onChange={handleCoinChange}
                          min="0"
                        />
                        <Form.Text className="text-muted">
                          Yeni üyelerin başlangıç jeton miktarı
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Mesaj Coin</Form.Label>
                        <Form.Control
                          type="number"
                          name="messageCoin"
                          value={coinSettings.messageCoin}
                          onChange={handleCoinChange}
                          min="0"
                        />
                        <Form.Text className="text-muted">
                          Her mesaj için harcanacak jeton miktarı
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Resim Coin</Form.Label>
                        <Form.Control
                          type="number"
                          name="imageCoin"
                          value={coinSettings.imageCoin}
                          onChange={handleCoinChange}
                          min="0"
                        />
                        <Form.Text className="text-muted">
                          Her fotoğraf gönderimi için harcanacak jeton miktarı
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Video Coin</Form.Label>
                        <Form.Control
                          type="number"
                          name="videoCoin"
                          value={coinSettings.videoCoin}
                          onChange={handleCoinChange}
                          min="0"
                        />
                        <Form.Text className="text-muted">
                          Her video gönderimi için harcanacak jeton miktarı
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Ses Coin</Form.Label>
                        <Form.Control
                          type="number"
                          name="voiceCoin"
                          value={coinSettings.voiceCoin}
                          onChange={handleCoinChange}
                          min="0"
                        />
                        <Form.Text className="text-muted">
                          Her ses kaydı gönderimi için harcanacak jeton miktarı
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Sesli/Görüntülü Arama Coin</Form.Label>
                        <Form.Control
                          type="number"
                          name="callCoin"
                          value={coinSettings.callCoin || 150}
                          onChange={handleCoinChange}
                          min="0"
                        />
                        <Form.Text className="text-muted">
                          Her sesli veya görüntülü arama için harcanacak jeton miktarı
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Paylaşım</Form.Label>
                        <Form.Control
                          type="number"
                          name="postCoin"
                          value={coinSettings.postCoin || 0}
                          onChange={handleCoinChange}
                          min="0"
                        />
                        <Form.Text className="text-muted">
                          Her paylaşım (gönderi) için harcanacak jeton miktarı. 0 ise sadece Premium üyelik yeterlidir.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Hikaye Coins</Form.Label>
                        <Form.Control
                          type="number"
                          name="storyCoin"
                          value={coinSettings.storyCoin || 0}
                          onChange={handleCoinChange}
                          min="0"
                        />
                        <Form.Text className="text-muted">
                          Her hikaye paylaşımı için harcanacak jeton miktarı. 0 ise sadece Premium üyelik yeterlidir.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Gold Profil Bio Jeton</Form.Label>
                        <Form.Control
                          type="number"
                          name="goldBioViewCoin"
                          value={coinSettings.goldBioViewCoin || 300}
                          onChange={handleCoinChange}
                          min="0"
                        />
                        <Form.Text className="text-muted">
                          Gold profillerin biyografilerini görmek için harcanacak jeton miktarı.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Yorum Coins</Form.Label>
                        <Form.Control
                          type="number"
                          name="commentCoin"
                          value={coinSettings.commentCoin || 0}
                          onChange={handleCoinChange}
                          min="0"
                        />
                        <Form.Text className="text-muted">
                          Her yorum için harcanacak jeton miktarı. 0 ise yorum ücretsizdir.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-4">
                    <Col md={12}>
                      <Form.Group>
                        <div className="d-flex align-items-center justify-content-between p-3 border rounded bg-white">
                          <div>
                            <Form.Label className="mb-0 fw-bold">Yorum İçin Premium Gerekli</Form.Label>
                            <Form.Text className="text-muted d-block mt-1">
                              Aktif edildiğinde sadece Premium ve Doğrulanmış kullanıcılar yorum yapabilir. Kapalıyken herkes (jetona dayalı olarak) yorum yapabilir.
                            </Form.Text>
                          </div>
                          <Form.Check
                            type="switch"
                            id="isCommentPremiumRequired"
                            checked={coinSettings.isCommentPremiumRequired !== false} // Default to true if missing
                            onChange={(e) => setCoinSettings(prev => ({
                              ...prev,
                              isCommentPremiumRequired: e.target.checked
                            }))}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <div className="d-flex justify-content-end">
                    <Button
                      variant="primary"
                      type="submit"
                      disabled={loading}
                    >
                      {loading ? 'Kaydediliyor...' : 'Kaydet'}
                    </Button>
                  </div>
                </Form>
              </Tab.Pane>

              <Tab.Pane eventKey="firstMessage">
                <h5 className="mb-4">İlk Mesaj Ayarları</h5>

                {saveSuccess && (
                  <Alert variant="success" className="mb-3">
                    Ayarlar başarıyla kaydedildi!
                  </Alert>
                )}

                <Form>
                  <Card className="bg-light border-0 p-3 mb-4">
                    <h6 className="mb-3">Mesaj Zamanlaması</h6>
                    <Form.Group className="mb-3">
                      <Form.Label>Mesaj Süresi (Dakika)</Form.Label>
                      <Form.Control
                        type="number"
                        name="messageDelayMinutes"
                        value={firstMessageSettings.messageDelayMinutes || 5}
                        onChange={handleFirstMessageSettingsChange}
                        min="1"
                      />
                      <Form.Text className="text-muted">
                        Yeni üye olduktan sonra kaç dakika sonra otomatik mesaj gönderilecek (örn: 5)
                      </Form.Text>
                    </Form.Group>
                    <div className="d-flex justify-content-end">
                      <Button
                        variant="primary"
                        onClick={handleSaveFirstMessageSettings}
                        disabled={loading}
                      >
                        {loading ? 'Kaydediliyor...' : 'Kaydet'}
                      </Button>
                    </div>
                  </Card>

                  <Card className="bg-light border-0 p-3 mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6 className="mb-0">Mesaj İçeriği</h6>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={handleAddMessage}
                      >
                        Mesaj Ekle
                      </Button>
                    </div>
                    <Form.Text className="text-muted d-block mb-3">
                      Yeni üyelere gönderilecek mesajlar. Online fake hesaplardan random olarak seçilerek gönderilir.
                    </Form.Text>
                    {firstMessages.length === 0 ? (
                      <p className="text-muted mb-0">Henüz mesaj eklenmemiş.</p>
                    ) : (
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th style={{ width: '70%' }}>Mesaj İçeriği</th>
                            <th style={{ width: '30%' }}>İşlemler</th>
                          </tr>
                        </thead>
                        <tbody>
                          {firstMessages.map((message) => (
                            <tr key={message.id}>
                              <td>{message.text}</td>
                              <td>
                                <Button
                                  variant="warning"
                                  size="sm"
                                  className="me-2"
                                  onClick={() => handleEditMessage(message)}
                                >
                                  Düzenle
                                </Button>
                                <Button
                                  variant="danger"
                                  size="sm"
                                  onClick={() => handleDeleteMessage(message.id)}
                                >
                                  Sil
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    )}
                  </Card>

                  <Card className="bg-light border-0 p-3 mb-4">
                    <h6 className="mb-3">Hangi Hesaplar Mesaj Atacak?</h6>
                    <p className="text-muted mb-3">
                      Sadece "Doğrulandı" (onaylı) durumundaki fake hesaplar otomatik olarak mesaj gönderecektir.
                      Eğer aşağıdan belirli hesapları seçerseniz, SADECE o hesaplar mesaj atar.
                      Hiçbir hesap seçilmezse, tüm onaylı fake hesaplar arasından rastgele seçim yapılır.
                    </p>
                    <Form.Group>
                      <Form.Label>Mesaj Atacak Fake Hesaplar</Form.Label>
                      <Select
                        isMulti
                        name="fakeAccounts"
                        options={fakeAccounts}
                        className="basic-multi-select"
                        classNamePrefix="select"
                        placeholder="Hesap seçiniz (Boş bırakılırsa hepsi seçilir)"
                        value={fakeAccounts.filter(acc =>
                          (firstMessageSettings.selectedFakeAccountIds || []).includes(acc.value)
                        )}
                        onChange={handleFakeAccountSelectChange}
                        noOptionsMessage={() => "Doğrulanmış durumda fake hesap bulunamadı."}
                      />
                    </Form.Group>
                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        variant="primary"
                        onClick={handleSaveFirstMessageSettings}
                        disabled={loading}
                      >
                        {loading ? 'Kaydediliyor...' : 'Secimleri Kaydet'}
                      </Button>
                    </div>
                  </Card>
                </Form>

                {/* Mesaj Ekleme/Düzenleme Modal */}
                <Modal show={showMessageModal} onHide={() => {
                  setShowMessageModal(false);
                  setMessageText("");
                  setEditingMessage(null);
                }}>
                  <Modal.Header closeButton>
                    <Modal.Title>
                      {editingMessage ? 'Mesaj Düzenle' : 'Yeni Mesaj Ekle'}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group>
                      <Form.Label>Mesaj İçeriği</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        value={messageText}
                        onChange={(e) => setMessageText(e.target.value)}
                        placeholder="Örn: Merhaba {{first_uye_name}}, {{uye_sehir_da}} seni arayan biri var!"
                      />
                      <div className="d-flex gap-2 mt-2">
                        <Button
                          variant="outline-info"
                          size="sm"
                          onClick={() => setMessageText(prev => prev + '{{first_uye_name}}')}
                        >
                          👤 İsim Ekle
                        </Button>
                        <Button
                          variant="outline-info"
                          size="sm"
                          onClick={() => setMessageText(prev => prev + '{{uye_sehir_da}}')}
                        >
                          📍 Şehir Ekle
                        </Button>
                      </div>
                      <Form.Text className="text-muted d-block mt-2">
                        Değişkenler: <code>{'{{first_uye_name}}'}</code> = Üyenin adı, <code>{'{{uye_sehir_da}}'}</code> = Şehir + Türkçe eki (örn: İstanbul'da)
                      </Form.Text>
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={() => {
                      setShowMessageModal(false);
                      setMessageText("");
                      setEditingMessage(null);
                    }}>
                      İptal
                    </Button>
                    <Button variant="primary" onClick={handleSaveMessage}>
                      {editingMessage ? 'Güncelle' : 'Ekle'}
                    </Button>
                  </Modal.Footer>
                </Modal>
              </Tab.Pane>

              <Tab.Pane eventKey="media">
                <h5 className="mb-4">Premium Medya Ayarları</h5>

                {saveSuccess && (
                  <Alert variant="success" className="mb-3">
                    Ayarlar başarıyla kaydedildi!
                  </Alert>
                )}

                <Form>
                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Medya Görüntüleme</h6>
                    <Form.Check
                      type="switch"
                      id="viewImage"
                      label="Fotoğraf görmek için premium gerekli"
                      name="requirePremiumToViewImage"
                      checked={premiumSettings.requirePremiumToViewImage}
                      onChange={handlePremiumChange}
                      className="mb-2"
                    />
                    <Form.Check
                      type="switch"
                      id="viewVideo"
                      label="Video izlemek için premium gerekli"
                      name="requirePremiumToViewVideo"
                      checked={premiumSettings.requirePremiumToViewVideo}
                      onChange={handlePremiumChange}
                      className="mb-2"
                    />
                    <Form.Check
                      type="switch"
                      id="viewAudio"
                      label="Ses kaydı dinlemek için premium gerekli"
                      name="requirePremiumToViewAudio"
                      checked={premiumSettings.requirePremiumToViewAudio}
                      onChange={handlePremiumChange}
                    />
                  </Card>

                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Medya Gönderme</h6>
                    <Form.Check
                      type="switch"
                      id="sendImage"
                      label="Fotoğraf göndermek için premium gerekli"
                      name="requirePremiumToSendImage"
                      checked={premiumSettings.requirePremiumToSendImage}
                      onChange={handlePremiumChange}
                      className="mb-2"
                    />
                    <Form.Check
                      type="switch"
                      id="sendVideo"
                      label="Video göndermek için premium gerekli"
                      name="requirePremiumToSendVideo"
                      checked={premiumSettings.requirePremiumToSendVideo}
                      onChange={handlePremiumChange}
                      className="mb-2"
                    />
                    <Form.Check
                      type="switch"
                      id="sendAudio"
                      label="Ses kaydı göndermek için premium gerekli"
                      name="requirePremiumToSendAudio"
                      checked={premiumSettings.requirePremiumToSendAudio}
                      onChange={handlePremiumChange}
                    />
                  </Card>

                  <div className="d-flex justify-content-end">
                    <Button
                      variant="primary"
                      onClick={handleSavePremiumSettings}
                      disabled={loading}
                    >
                      {loading ? 'Kaydediliyor...' : 'Kaydet'}
                    </Button>
                  </div>
                </Form>
              </Tab.Pane>

              <Tab.Pane eventKey="special">
                <h5 className="mb-4">Canlı Yayın Ayarları</h5>

                {saveSuccess && (
                  <Alert variant="success" className="mb-3">
                    Ayarlar başarıyla kaydedildi!
                  </Alert>
                )}

                <Form>
                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Genel Ayarlar</h6>
                    <Form.Check
                      type="switch"
                      id="liveStreamEnabled"
                      label="Canlı Yayın Sekmesi Aktif"
                      name="isEnabled"
                      checked={liveStreamSettings.isEnabled}
                      onChange={handleLiveStreamChange}
                      className="mb-3"
                    />
                    <Form.Text className="text-muted d-block mb-3">
                      Kapalı olduğunda uygulamada canlı yayın sekmesi görünmez.
                    </Form.Text>
                  </Card>

                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Yayın Başlatma</h6>
                    <Form.Group className="mb-3">
                      <Form.Label>Canlı Yayın Başlatma Jeton Maliyeti</Form.Label>
                      <Form.Control
                        type="number"
                        name="startStreamCoinCost"
                        value={liveStreamSettings.startStreamCoinCost}
                        onChange={handleLiveStreamChange}
                        min="0"
                      />
                      <Form.Text className="text-muted">
                        Diamond üye olmayan kullanıcılar için yayın başlatma jeton maliyeti (örn: 10000)
                      </Form.Text>
                    </Form.Group>
                  </Card>

                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">İzleme Modu</h6>
                    <Form.Group className="mb-3">
                      <Form.Label>İzleme Modu</Form.Label>
                      <Form.Select
                        name="watchMode"
                        value={liveStreamSettings.watchMode}
                        onChange={handleLiveStreamChange}
                      >
                        <option value="premium">Premium ile İzleme</option>
                        <option value="coin">Jeton ile İzleme</option>
                      </Form.Select>
                      <Form.Text className="text-muted">
                        Kullanıcıların canlı yayınları izleme şekli
                      </Form.Text>
                    </Form.Group>
                  </Card>

                  {liveStreamSettings.watchMode === "premium" && (
                    <Card className="bg-light border-0 p-3 mb-3">
                      <h6 className="mb-3">Premium İzleme Ayarları</h6>
                      <Form.Check
                        type="switch"
                        id="requirePremiumToWatch"
                        label="İzlemek için Premium Gerekli"
                        name="requirePremiumToWatch"
                        checked={liveStreamSettings.requirePremiumToWatch}
                        onChange={handleLiveStreamChange}
                        className="mb-3"
                      />
                      {liveStreamSettings.requirePremiumToWatch && (
                        <Form.Group className="mb-3">
                          <Form.Label>Ücretsiz İzleme Süresi (Dakika)</Form.Label>
                          <Form.Control
                            type="number"
                            name="freeWatchMinutesPremium"
                            value={liveStreamSettings.freeWatchMinutesPremium}
                            onChange={handleLiveStreamChange}
                            min="0"
                          />
                          <Form.Text className="text-muted">
                            0 girilirse premium olmayanlar izleyemez. 0'dan yüksek değerler ücretsiz izleme dakikasıdır.
                          </Form.Text>
                        </Form.Group>
                      )}
                    </Card>
                  )}

                  {liveStreamSettings.watchMode === "coin" && (
                    <Card className="bg-light border-0 p-3 mb-3">
                      <h6 className="mb-3">Jeton ile İzleme Ayarları</h6>
                      <Form.Check
                        type="switch"
                        id="watchWithCoin"
                        label="Jeton ile İzleme Aktif"
                        name="watchWithCoin"
                        checked={liveStreamSettings.watchWithCoin}
                        onChange={handleLiveStreamChange}
                        className="mb-3"
                      />
                      {liveStreamSettings.watchWithCoin && (
                        <>
                          <Form.Group className="mb-3">
                            <Form.Label>İzleme Jeton Maliyeti</Form.Label>
                            <Form.Control
                              type="number"
                              name="watchCoinCost"
                              value={liveStreamSettings.watchCoinCost}
                              onChange={handleLiveStreamChange}
                              min="0"
                            />
                            <Form.Text className="text-muted">
                              Ücretsiz izleme süresi dolduktan sonra izlemeye devam etmek için gerekli jeton miktarı (örn: 1000)
                            </Form.Text>
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label>Ücretsiz İzleme Süresi (Dakika)</Form.Label>
                            <Form.Control
                              type="number"
                              name="freeWatchMinutesCoin"
                              value={liveStreamSettings.freeWatchMinutesCoin}
                              onChange={handleLiveStreamChange}
                              min="0"
                            />
                            <Form.Text className="text-muted">
                              Her hesap için ücretsiz izleme dakikası (örn: 1)
                            </Form.Text>
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label>Jeton ile Maksimum İzleme Süresi (Dakika)</Form.Label>
                            <Form.Control
                              type="number"
                              name="watchCoinDurationMinutes"
                              value={liveStreamSettings.watchCoinDurationMinutes}
                              onChange={handleLiveStreamChange}
                              min="1"
                            />
                            <Form.Text className="text-muted">
                              Jeton ödendikten sonra maksimum izlenebilecek süre (örn: 20)
                            </Form.Text>
                          </Form.Group>
                        </>
                      )}
                    </Card>
                  )}

                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Canlı Yayın Chat Ayarları</h6>
                    <Form.Group className="mb-3">
                      <Form.Label>Canlı Yayın Mesaj Jeton Maliyeti</Form.Label>
                      <Form.Control
                        type="number"
                        name="chatMessageCoinCost"
                        value={liveStreamSettings.chatMessageCoinCost || 1}
                        onChange={handleLiveStreamChange}
                        min="0"
                      />
                      <Form.Text className="text-muted">
                        Canlı yayında gönderilen her mesaj için harcanacak jeton miktarı (örn: 1)
                      </Form.Text>
                    </Form.Group>
                  </Card>

                  <div className="d-flex justify-content-end">
                    <Button
                      variant="primary"
                      onClick={handleSaveLiveStreamSettings}
                      disabled={loading}
                    >
                      {loading ? 'Kaydediliyor...' : 'Kaydet'}
                    </Button>
                  </div>
                </Form>
              </Tab.Pane>

              <Tab.Pane eventKey="creditcard">
                <h5 className="mb-4">Kredi Kartı Ödeme Entegrasyonu</h5>

                {saveSuccess && (
                  <Alert variant="success" className="mb-3">
                    Ayarlar başarıyla kaydedildi!
                  </Alert>
                )}

                <Form>
                  <Row className="mb-3">
                    <Col md={12}>
                      <Form.Group>
                        <Form.Check
                          type="switch"
                          id="creditCardEnabled"
                          label="Kredi Kartı Ödeme Entegrasyonu"
                          name="enabled"
                          checked={creditCardSettings.enabled}
                          onChange={handleCreditCardChange}
                        />
                        <Form.Text className="text-muted">
                          Açıldığında uygulamada kredi kartı ile ödeme seçeneği gösterilir.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>Kredi Kartı URL</Form.Label>
                        <Form.Control
                          type="text"
                          name="paymentUrl"
                          value={creditCardSettings.paymentUrl}
                          onChange={handleCreditCardChange}
                          placeholder="https://insbayim.com/paytrapi2/"
                        />
                        <Form.Text className="text-muted">
                          PayTR veya diğer ödeme sağlayıcı API URL'i
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>İndirim Metni</Form.Label>
                        <Form.Control
                          type="text"
                          name="discountText"
                          value={creditCardSettings.discountText}
                          onChange={handleCreditCardChange}
                          placeholder="%5 indirim ile jeton al"
                        />
                        <Form.Text className="text-muted">
                          Kredi kartı ile ödeme seçeneğinde gösterilecek metin
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label>İndirim Yüzdesi</Form.Label>
                        <Form.Control
                          type="number"
                          name="discountPercent"
                          value={creditCardSettings.discountPercent}
                          onChange={handleCreditCardChange}
                          min="0"
                          max="100"
                        />
                        <Form.Text className="text-muted">
                          Kredi kartı ile ödemede uygulanacak indirim yüzdesi (örn: 5 = %5)
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12} className="text-end">
                      <Button
                        variant="primary"
                        onClick={handleSaveCreditCardSettings}
                        disabled={loading}
                      >
                        {loading ? 'Kaydediliyor...' : 'Kaydet'}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Tab.Pane>

              <Tab.Pane eventKey="payment">
                <p className="text-muted">Ödeme ayarları burada gösterilecek...</p>
              </Tab.Pane>

              <Tab.Pane eventKey="notification">
                <p className="text-muted">Bildirim ayarları burada gösterilecek...</p>
              </Tab.Pane>

              <Tab.Pane eventKey="other">
                <h5 className="mb-4">Diğer Uygulama Ayarları</h5>

                {saveSuccess && (
                  <Alert variant="success" className="mb-3">
                    Ayarlar başarıyla kaydedildi!
                  </Alert>
                )}

                <Form>
                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Profil Doğrulama</h6>
                    <Form.Check
                      type="switch"
                      id="faceVerificationEnabled"
                      label="Yüz Doğrulama Özelliği Aktif"
                      name="faceVerificationEnabled"
                      checked={otherSettings.faceVerificationEnabled}
                      onChange={handleOtherSettingsChange}
                    />
                    <Form.Text className="text-muted d-block mt-2">
                      Kapatıldığında uygulamada yer alan "Hesabını Doğrula" butonu tamamen gizlenir.
                    </Form.Text>
                  </Card>

                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Güvenlik Ayarları</h6>
                    <Form.Check
                      type="switch"
                      id="isScreenshotPreventionEnabled"
                      label="Ekran Görüntüsü Engelleme Aktif"
                      name="isScreenshotPreventionEnabled"
                      checked={otherSettings.isScreenshotPreventionEnabled}
                      onChange={handleOtherSettingsChange}
                    />
                    <Form.Text className="text-muted d-block mt-2">
                      Açıldığında uygulamada ekran görüntüsü alınması ve ekran kaydı yapılması engellenir.
                    </Form.Text>
                  </Card>

                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Vibes (Reels) Ayarları</h6>
                    <Form.Check
                      type="switch"
                      id="vibesEnabled"
                      label="Vibes Videolar Aktif"
                      name="vibesEnabled"
                      checked={otherSettings.vibesEnabled}
                      onChange={handleOtherSettingsChange}
                    />
                    <Form.Text className="text-muted d-block mt-2">
                      Kapalı olduğunda uygulamadaki Vibes (Reels) sekmesi gizlenir ve navigatör 4 butona düşer.
                    </Form.Text>
                  </Card>

                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Sosyal Ekran Ayarları</h6>
                    <Form.Check
                      type="switch"
                      id="socialFeedEnabled"
                      label="Sosyal Akış (Ana Sayfa) Aktif"
                      name="socialFeedEnabled"
                      checked={otherSettings.socialFeedEnabled !== false}
                      onChange={handleOtherSettingsChange}
                    />
                    <Form.Text className="text-muted d-block mt-2">
                      Kapalı olduğunda uygulamadaki Ana Sayfa (Sosyal Akış / Stories / Posts) sekmesi alt navigasyondan gizlenir. Kullanıcılar sosyal içeriklere erişemez.
                    </Form.Text>
                  </Card>

                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Yorum Ayarları</h6>
                    <Form.Check
                      type="switch"
                      id="isCommentingEnabled"
                      label="Gönderi Yorumları Aktif"
                      name="isCommentingEnabled"
                      checked={otherSettings.isCommentingEnabled !== false}
                      onChange={handleOtherSettingsChange}
                    />
                    <Form.Text className="text-muted d-block mt-2">
                      Açıldığında uygulamada kullanıcıların birbirine yorum yapması serbest olur, kapalıyken engel kalkar.
                    </Form.Text>
                  </Card>

                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Doğrulanmış Rozet Sku</h6>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        name="verifiedBadgeSku"
                        value={otherSettings.verifiedBadgeSku || ''}
                        onChange={handleOtherSettingsChange}
                        placeholder="Google Play üzerinde tanımlı in-app product SKU'su"
                      />
                      <Form.Text className="text-muted d-block mt-2">
                        Kullanıcıların tek seferlik Doğrulanmış Rozet (Mavi Tik) satın alabilmesi için gereken Google Play Store SKU bilgisidir.
                      </Form.Text>
                    </Form.Group>
                  </Card>

                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Giriş ve Kayıt Ayarları</h6>
                    <Form.Check
                      type="switch"
                      id="onlyGoogleLoginEnabled"
                      label="Sadece Google Girişini Aktif Et"
                      name="onlyGoogleLoginEnabled"
                      checked={otherSettings.onlyGoogleLoginEnabled || false}
                      onChange={handleOtherSettingsChange}
                    />
                    <Form.Text className="text-muted d-block mt-2">
                      Açıldığında Android uygulamasında "Telefon" ve "E-Posta" ile giriş ekranları tamamen gizlenir, yeni üyeler ve eski üyeler sadece Google ile devam edebilir.
                    </Form.Text>
                  </Card>

                  <div className="d-flex justify-content-end">
                    <Button
                      variant="primary"
                      onClick={handleSaveOtherSettings}
                      disabled={loading}
                    >
                      {loading ? 'Kaydediliyor...' : 'Kaydet'}
                    </Button>
                  </div>
                </Form>
              </Tab.Pane>

              <Tab.Pane eventKey="updates">
                <h5 className="mb-4">Güncelleme ve Bakım Yönetimi</h5>

                {saveSuccess && (
                  <Alert variant="success" className="mb-3">
                    Ayarlar başarıyla kaydedildi!
                  </Alert>
                )}

                <Card className="bg-light border-0 p-3 mb-4">
                  <h6 className="mb-3">Global Güncelleme & Bakım Ayarları</h6>
                  <Form>
                    <Row>
                      <Col md={12}>
                        <Form.Check
                          type="switch"
                          id="maintenanceMode"
                          label="Bakım Modu Aktif"
                          name="maintenance"
                          checked={updateSettings.maintenance}
                          onChange={handleUpdateSettingsChange}
                          className="mb-2"
                        />
                        <Form.Text className="text-muted d-block mb-3">
                          Açıldığında tüm kullanıcılar bakım ekranını görür.
                        </Form.Text>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="mb-3">
                          <Form.Label>Bakım Mesajı</Form.Label>
                          <Form.Control
                            type="text"
                            name="maintenanceMessage"
                            value={updateSettings.maintenanceMessage}
                            onChange={handleUpdateSettingsChange}
                            placeholder="Sunucu bakımı yapılıyor..."
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="mb-3">
                          <Form.Label>Minimum Desteklenen Versiyon Kodu</Form.Label>
                          <Form.Control
                            type="number"
                            name="minSupportedVersion"
                            value={updateSettings.minSupportedVersion}
                            onChange={handleUpdateSettingsChange}
                          />
                          <Form.Text className="text-muted">
                            Bu kodun altındaki tüm sürümler zorunlu güncellemeye yönlendirilir.
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>
                    <div className="d-flex justify-content-end">
                      <Button variant="primary" onClick={handleSaveUpdateSettings} disabled={loading}>
                        {loading ? 'Kaydediliyor...' : 'Kaydet'}
                      </Button>
                    </div>
                  </Form>
                </Card>

                <Card className="bg-light border-0 p-3">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0">Sürüm Bazlı Kontroller</h6>
                    <Button variant="primary" size="sm" onClick={() => {
                      setVersionData({
                        versionCode: 0,
                        status: "allowed",
                        forceUpdate: false,
                        softUpdate: false,
                        message: "",
                        updateUrl: "https://play.google.com/store/apps/details?id=com.jigo.go"
                      });
                      setEditingVersion(null);
                      setShowVersionModal(true);
                    }}>
                      Sürüm Ekle
                    </Button>
                  </div>
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>VersionCode</th>
                        <th>Status</th>
                        <th>Force</th>
                        <th>Soft</th>
                        <th>Message</th>
                        <th>İşlemler</th>
                      </tr>
                    </thead>
                    <tbody>
                      {versionList.map((v) => (
                        <tr key={v.id}>
                          <td>{v.versionCode}</td>
                          <td>
                            <span className={`badge bg-${v.status === 'blocked' ? 'danger' : 'success'}`}>
                              {v.status}
                            </span>
                          </td>
                          <td>{v.forceUpdate ? '✅' : '❌'}</td>
                          <td>{v.softUpdate ? '✅' : '❌'}</td>
                          <td className="small">{v.message}</td>
                          <td>
                            <Button variant="warning" size="sm" className="me-2" onClick={() => {
                              setVersionData(v);
                              setEditingVersion(v);
                              setShowVersionModal(true);
                            }}>Düzenle</Button>
                            <Button variant="danger" size="sm" onClick={() => handleDeleteVersion(v.id)}>Sil</Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card>

                <Modal show={showVersionModal} onHide={() => { setShowVersionModal(false); setEditingVersion(null); }}>
                  <Modal.Header closeButton>
                    <Modal.Title>{editingVersion ? 'Sürüm Düzenle' : 'Yeni Sürüm Ekle'}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form>
                      <Form.Group className="mb-3">
                        <Form.Label>Version Code</Form.Label>
                        <Form.Control
                          type="number"
                          name="versionCode"
                          value={versionData.versionCode}
                          onChange={handleVersionDataChange}
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Durum</Form.Label>
                        <Form.Select name="status" value={versionData.status} onChange={handleVersionDataChange}>
                          <option value="allowed">Allowed</option>
                          <option value="blocked">Blocked</option>
                        </Form.Select>
                      </Form.Group>
                      <Form.Check
                        type="switch"
                        label="Zorunlu Güncelleme (Force Update)"
                        name="forceUpdate"
                        checked={versionData.forceUpdate}
                        onChange={handleVersionDataChange}
                        className="mb-2"
                      />
                      <Form.Check
                        type="switch"
                        label="Yumuşak Güncelleme (Soft Update)"
                        name="softUpdate"
                        checked={versionData.softUpdate}
                        onChange={handleVersionDataChange}
                        className="mb-3"
                      />
                      <Form.Group className="mb-3">
                        <Form.Label>Özel Mesaj (Opsiyonel)</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          name="message"
                          value={versionData.message}
                          onChange={handleVersionDataChange}
                          placeholder="Bu sürümde hata giderildi..."
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label>Güncelleme Linki (Opsiyonel)</Form.Label>
                        <Form.Control
                          type="text"
                          name="updateUrl"
                          value={versionData.updateUrl}
                          onChange={handleVersionDataChange}
                          placeholder="https://play.google.com/store/apps/details?id=..."
                        />
                        <Form.Text className="text-muted">
                          Boş bırakılırsa varsayılan Google Play linki kullanılır. Farklı bir uygulamaya yönlendirmek için tam URL girin.
                        </Form.Text>
                      </Form.Group>
                    </Form>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowVersionModal(false)}>İptal</Button>
                    <Button variant="primary" onClick={handleSaveVersion} disabled={loading}>Kaydet</Button>
                  </Modal.Footer>
                </Modal>
              </Tab.Pane>

              <Tab.Pane eventKey="system">
                <p className="text-muted">Sistem işlemleri burada gösterilecek...</p>
              </Tab.Pane>

              <Tab.Pane eventKey="ai">
                <h5 className="mb-4">Yapay Zeka (Sohbet) Ayarları</h5>

                {saveSuccess && (
                  <Alert variant="success" className="mb-3">
                    Ayarlar başarıyla kaydedildi!
                  </Alert>
                )}

                <Form>
                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Genel Ayarlar</h6>
                    <Form.Check
                      type="switch"
                      id="aiEnabled"
                      label="Yapay Zeka Aktif mi?"
                      name="isEnabled"
                      checked={aiSettings.isEnabled}
                      onChange={handleAiChange}
                      className="mb-3"
                    />
                    
                    <Form.Group className="mb-3">
                      <Form.Label>Aktif Model</Form.Label>
                      <Form.Select
                        name="provider"
                        value={aiSettings.provider}
                        onChange={handleAiChange}
                      >
                        <option value="claude">Claude (claude-3-5-sonnet-latest)</option>
                        <option value="chatgpt">ChatGPT (gpt-4o-mini)</option>
                      </Form.Select>
                      <Form.Text className="text-muted">
                        Hangi yapay zekanın yanıt vereceğini seçin.
                      </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>Gecikme Süresi (Saniye)</Form.Label>
                      <Form.Control
                        type="number"
                        name="delaySeconds"
                        value={aiSettings.delaySeconds}
                        onChange={handleAiChange}
                        min="0"
                      />
                      <Form.Text className="text-muted">
                        Mesaj geldiğinde yapay zekanın yanıt vermek için bekleyeceği saniye (Doğallık için 5-10 saniye önerilir).
                      </Form.Text>
                    </Form.Group>
                  </Card>

                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">API Anahtarları</h6>
                    <Form.Group className="mb-3">
                      <Form.Label>ChatGPT (OpenAI) API Key</Form.Label>
                      <Form.Control
                        type="text"
                        name="openaiKey"
                        value={aiSettings.openaiKey}
                        onChange={handleAiChange}
                        placeholder="sk-..."
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Claude (Anthropic) API Key</Form.Label>
                      <Form.Control
                        type="text"
                        name="anthropicKey"
                        value={aiSettings.anthropicKey}
                        onChange={handleAiChange}
                        placeholder="sk-ant-..."
                      />
                    </Form.Group>
                  </Card>

                  <Card className="bg-light border-0 p-3 mb-3">
                    <h6 className="mb-3">Karakter / Sistem Komutu (System Prompt)</h6>
                    <Form.Group className="mb-3">
                      <Form.Control
                        as="textarea"
                        rows={6}
                        name="systemPrompt"
                        value={aiSettings.systemPrompt}
                        onChange={handleAiChange}
                      />
                      <Form.Text className="text-muted">
                        Yapay zekanın nasıl davranacağını buradan belirleyebilirsiniz.
                      </Form.Text>
                    </Form.Group>
                  </Card>

                  <div className="d-flex justify-content-end">
                    <Button
                      variant="primary"
                      onClick={handleSaveAiSettings}
                      disabled={loading}
                    >
                      {loading ? 'Kaydediliyor...' : 'Kaydet'}
                    </Button>
                  </div>
                </Form>
              </Tab.Pane>

              {/* ═══════ ETKİLEŞİM SKORU TAB ═══════ */}
              <Tab.Pane eventKey="engagement">
                <h5 className="mb-3">🔥 Etkileşim Skoru — Top Çevrimiçi Profiller</h5>
                <Alert variant="info">
                  <strong>Nasıl Çalışır?</strong> Bu işlem tüm onaylı kullanıcıların <strong>profil beğenisi + paylaşım beğenisi</strong> toplamını hesaplar ve en yüksek skorlu profilleri "Çevrimiçi" olarak uygulamada gösterir.
                  <br /><small className="text-muted">Maliyet: Tek seferlik okuma + tek doküman yazma. App tarafında ek maliyet yok.</small>
                </Alert>

                <Row className="mb-3">
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label>Top Kaç Profil?</Form.Label>
                      <Form.Control
                        type="number"
                        value={topEngagedCount}
                        onChange={(e) => setTopEngagedCount(parseInt(e.target.value) || 50)}
                        min="10"
                        max="200"
                      />
                      <Form.Text className="text-muted">
                        Çevrimiçi olarak gösterilecek maksimum profil sayısı
                      </Form.Text>
                    </Form.Group>
                  </Col>
                  <Col md={4} className="d-flex align-items-end">
                    <Button
                      variant="success"
                      onClick={calculateTopEngaged}
                      disabled={engagementLoading}
                      className="w-100"
                    >
                      {engagementLoading ? '⏳ Hesaplanıyor...' : '🔄 Etkileşim Skorunu Hesapla'}
                    </Button>
                  </Col>
                  <Col md={4} className="d-flex align-items-end">
                    {topEngagedUpdatedAt && (
                      <small className="text-muted">
                        Son güncelleme: {new Date(topEngagedUpdatedAt).toLocaleString('tr-TR')}
                      </small>
                    )}
                  </Col>
                </Row>

                {engagementLoading && (
                  <div className="mb-3">
                    <ProgressBar now={engagementProgress} label={`${engagementProgress}%`} animated />
                    <small className="text-muted mt-1 d-block">{engagementMessage}</small>
                  </div>
                )}

                {engagementMessage && !engagementLoading && (
                  <Alert variant={engagementMessage.includes('✅') ? 'success' : 'danger'} className="mb-3">
                    {engagementMessage}
                  </Alert>
                )}

                {topEngagedList.length > 0 && (
                  <Card className="border-0 shadow-sm">
                    <Card.Body style={{ maxHeight: '500px', overflowY: 'auto' }}>
                      <Table striped bordered hover size="sm">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Profil</th>
                            <th>İsim</th>
                            <th>Şehir</th>
                            <th>Profil ❤️</th>
                            <th>Paylaşım ❤️</th>
                            <th>Toplam Skor</th>
                          </tr>
                        </thead>
                        <tbody>
                          {topEngagedList.map((user, index) => (
                            <tr key={user.uid}>
                              <td>
                                {index < 3 ? (
                                  <Badge bg={index === 0 ? 'warning' : index === 1 ? 'secondary' : 'danger'}>
                                    {index + 1}
                                  </Badge>
                                ) : (index + 1)}
                              </td>
                              <td>
                                {user.profileImageUrl ? (
                                  <img
                                    src={user.profileImageUrl}
                                    alt=""
                                    style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover' }}
                                  />
                                ) : '—'}
                              </td>
                              <td>{user.name}</td>
                              <td>{user.city || '—'}</td>
                              <td>{user.profileLikes}</td>
                              <td>{user.postLikes}</td>
                              <td><strong>{user.totalScore}</strong></td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </Card.Body>
                  </Card>
                )}
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Card.Body>
      </Card >
    </>
  );
};
